<template>
  <Container>
    <Card :class="$style.card">
      <div :class="$style.titleBlock">
        <HeadingSmall :class="$style.title">
          Recent OS Releases
        </HeadingSmall>
        <TooltipIcon
          v-if="isWindowsTabSelected"
          :class="$style.tooltip"
          icon="info"
          orientation="right"
          :text="tooltipText"
        />
      </div>
      <OsReleasePatchTabs
        :showTabs="showTabs"
        :tabSelected="tabSelected"
      />
    </Card>
  </Container>
</template>

<script>
import { Container, HeadingSmall, TooltipIcon } from '@jumpcloud/ui-components';
import {
  DeviceTabs,
} from 'client/util/Constants';
import Card from 'components/Card.vue';
import OsReleasePatchTabs from 'client/OsManagement/OsReleasePatch/OsReleasePatchTabs';

export default {
  name: 'OsReleaseTrainsCard',

  components: {
    Card,
    Container,
    HeadingSmall,
    OsReleasePatchTabs,
    TooltipIcon,
  },

  props: {
    showTabs: {
      type: Boolean,
      default: true,
    },
    tabSelected: {
      type: String,
      default: '',
    },
  },

  computed: {
    isWindowsTabSelected() {
      return this.tabSelected.toLowerCase() === DeviceTabs.windows;
    },

    tooltipText() {
      return this.isWindowsTabSelected ? 'Displays the latest updates available through the Windows Updates for Business release channel' : '';
    },
  },
};
</script>

<style module>
@value itemTableZIndex from '~css/z-index.css';

.card {
  height: 100%;
}

.titleBlock {
  border-bottom: var(--jc-border);
  flex: 0 0 65%;
  height: 3rem;
  margin-bottom: var(--jc-spacer);
  padding-bottom: var(--jc-spacer);
}

.title {
  display: inline-block;
}

.tooltip.tooltip.tooltip {
  z-index: itemTableZIndex;
}

.tooltip.tooltip.tooltip button {
  height: auto;
  margin-left: 1rem;
  width: auto;
}

</style>
